import { useReduxState } from 'hooks';
import { Badge } from '..';
import { getMessageWithPlaceholders } from 'shared-locales';

interface Props {
  hideSuccessBadge?: boolean;
  maxPoints: number;
  points: number;
}

const TaskPointsBadge = ({
  hideSuccessBadge = false,
  maxPoints,
  points
}: Props) => {
  const { messages } = useReduxState();

  const pointsText =
    typeof points === 'number'
      ? getMessageWithPlaceholders({
          message: messages.commonNumberOfPoints,
          placeholders: {
            numberOfPoints: `${points} / ${maxPoints}`
          }
        })
      : '-';

  return (
    <>
      {maxPoints > 0 ? (
        <div className="score">
          <Badge
            aria-label={messages.tasksTaskPoints}
            category="dark"
            icon="trophy"
            text={pointsText}
          />

          {!hideSuccessBadge ? (
            <>
              {points === maxPoints ? (
                <Badge
                  category="success-light"
                  icon="check"
                  text={messages.commonCorrect}
                  style={{ marginLeft: 15 }}
                />
              ) : (
                <Badge
                  category="error-light"
                  icon="times"
                  text={messages.commonIncorrect}
                  style={{ marginLeft: 15 }}
                />
              )}
            </>
          ) : null}

          <style jsx>{`
            .score {
              display: flex;
              margin-top: 15px;
              margin-right: 15px;
            }
          `}</style>
        </div>
      ) : null}
    </>
  );
};

export default TaskPointsBadge;
